export default "__VITE_ASSET__46eedcbc__"